import { TableCell, TableRow } from "@mui/material"
import { getRuleImpactLabel } from "./rule-impact-label"

export function CostTimeModifierRow({ item }) {
    return (
        <TableRow data-cy="time-modifier-row">
            <TableCell>{getRuleImpactLabel(item)}</TableCell>
            <TableCell align="right">{item.taskCount}</TableCell>
            <TableCell align="right">{formatPerTask(item)}</TableCell>
        </TableRow>
    )
}

function formatPerTask(impact) {
    if (impact.timeKind === "percentage") {
        const pct = Math.round((Number(impact.timeValue) || 0) * 100)
        const sign = pct >= 0 ? "+" : ""
        return `${sign}${pct}% duration`
    }
    const value = Number(impact.timeValue) || 0
    const sign = value >= 0 ? "+" : ""
    return `${sign}${value} min`
}
